import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import click from './sounds/shortclick.mp3';
import icon from './images/icons8-place-marker-48.png';
import groundFloor from './images/FuTipMap_720px.png';
import rubbishbin_blue from './images/RubbishBin_blue.png';
import rubbishbin_orange from './images/RubbishBin_orange.png';
import rubbishbin_green from './images/RubbishBin_green.png';
import rubbishbin_yellow from './images/RubbishBin_yellow.png';
import rubbishbin_lg from './images/RubbishBin_light_grey.png';
import rubbishbin from './images/RubbishBin.png';
import rubbishbin10 from './images/RubbishBin_10.png';
import rubbishbin20 from './images/RubbishBin_20.png';
import rubbishbin30 from './images/RubbishBin_30.png';
import rubbishbin40 from './images/RubbishBin_40.png';
import rubbishbin50 from './images/RubbishBin_50.png';
import rubbishbin60 from './images/RubbishBin_60.png';
import rubbishbin70 from './images/RubbishBin_70.png';
import rubbishbin80 from './images/RubbishBin_80.png';
import rubbishbin90 from './images/RubbishBin_90.png';

// Constants
const FLOOR_WIDTH = 730;

export default function RubbishBins() {
    const [dev, setDev] = useState([]);
    const [displaydev, setDisplsyDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [hoveredDeviceId, setHoveredDeviceId] = useState(null);
    const [selectedChannel, setSelectedChannel] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const isInitialLoad = useRef(true);
    const [pins_g, setPins_g] = useState([]);

    // SignalR connection
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    const handleCellEnter = (deviceId) => {
        setHoveredDeviceId(deviceId);
        playClickSound();
    };

    const handleCellLeave = () => {
        setHoveredDeviceId(null);
    };

    const FloorplanImage = ({ src, alt }) => (
        <div className="estate-image" align-items="center">
            <img src={src} alt={alt} width={FLOOR_WIDTH} />
        </div>
    );

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net', 
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    mapx: item.mapx === null ? null : item.mapx * FLOOR_WIDTH / 720,
                    mapy: item.mapy === null ? null : item.mapy * FLOOR_WIDTH / 720,
                    type: item.type,
                    buildingId: item.buildingId,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    active: item.active,
                    unit: item.unit
                }));

                const scaledPin_2 = deviceDetails
                    .filter(device => device.data_type === 9)
                    .filter(device => device.mapx !== null && device.mapy !== null)
                    .map(device => ({ ...device, x: device.mapx, y: device.mapy }));

                console.log(scaledPin_2);
                setPins_g(scaledPin_2);
                console.log(deviceDetails);
                setDev(deviceDetails);

                const filteredDev = deviceDetails.filter(d => d.data_type === 9 && d.active === 1);
                setDisplsyDev(filteredDev);
                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };

        getData();
    }, [retry]);

    useEffect(() => {
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net', 
            headers: { 'Content-Type': 'application/json' }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    mapx: item.mapx === null ? null : item.mapx * FLOOR_WIDTH / 720,
                    mapy: item.mapy === null ? null : item.mapy * FLOOR_WIDTH / 720,
                    type: item.type,
                    buildingId: item.buildingId,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    active: item.active
                }));

                const scaledPin_2 = deviceDetails
                    .filter(device => device.data_type === 9)
                    .filter(device => device.mapx !== null && device.mapy !== null)
                    .map(device => ({ ...device, x: device.mapx, y: device.mapy }));

                console.log(scaledPin_2);
                setPins_g(scaledPin_2);
                console.log(deviceDetails);
                setDev(deviceDetails);

                const filteredDev = deviceDetails.filter(d => d.data_type === 9 && d.active === 1);
                setDisplsyDev(filteredDev);

                if (isInitialLoad.current) {
                    isInitialLoad.current = false;
                }
            } catch (error) {
                console.error(error);
            }
        };

        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        connection.on("ReceiveDeviceData", () => {
            console.log("Updating....");
            getData();
        });

        return () => {
            connection.off("ReceiveDeviceData");
        };
    }, []);

    const PinIcon = ({ id, x, y, isHovered, type }) => {
        return (
            <div style={{
                position: "absolute",
                left: `${x}px`,
                top: `${y}px`,
                transform: "translate(-50%, -50%)",
                zIndex: 5,
                cursor: "pointer"
            }}
                onMouseEnter={() => handleCellEnter(id)}
                onMouseLeave={handleCellLeave}
            >
                {(isHovered || type) && (
                    <div style={{
                        position: "absolute",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255, 215, 0, 0.3)",
                        border: "2px solid rgba(255, 215, 0, 0.8)",
                        animation: "pulse 1.5s infinite",
                        transform: "translate(-50%, -50%)",
                    }} />
                )}

                <div style={{
                    position: "absolute",
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: isHovered ? "yellow" : "red",
                    transform: "translate(-50%, -50%)",
                    transition: "all 0.3s ease",
                    boxShadow: isHovered ? "0 0 10px gold" : "none"
                }} />
            </div>
        );
    };

    const ImageWithPins = ({ pins, hoveredDeviceId }) => (
        <div>
            {pins.map((pin) => (
                <PinIcon
                    key={pin.id}
                    id={pin.id}
                    x={pin.x}
                    y={pin.y}
                    isHovered={hoveredDeviceId === pin.id}
                    type={pin.type === 0 ? false : true}
                />
            ))}
        </div>
    );

    function BinIcon(props) {
        let level = parseInt(props.x, 10);
        if (level < 10) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin} alt="rubbishbin" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 20) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin10} alt="rubbishbin10" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 30) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin20} alt="rubbishbin20" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 40) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin30} alt="rubbishbin30" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 50) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin40} alt="rubbishbin40" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 60) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin50} alt="rubbishbin50" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 70) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin60} alt="rubbishbin60" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 80) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin70} alt="rubbishbin70" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else if (level < 90) {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin80} alt="rubbishbin80" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={rubbishbin90} alt="rubbishbin90" width="60px" />
                    <img
                        src={props.src}
                        alt="Overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%', // or specific size
                            height: 'auto',
                        }}
                    />
                </div>
            );
        }
    };

    const cellColors_png = [

        rubbishbin_orange, // Orange
        rubbishbin_yellow, // Yellow
        rubbishbin_green, // Green
        rubbishbin_blue, // Blue
    ];

    const TextColors = [

        'orange', // Orange
        'yellow', // Yellow
        '#00FF00', // Green
        '#0000FF', // Blue
    ];
    function DeviceList() {
        return (
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '4px' }}>
                <tbody>
                    <tr>
                        <td colSpan="2" style={{ verticalAlign: 'top' }}>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '4px',
                                backgroundColor: '#888888',
                                borderRadius: '12px',
                                padding: '4px',
                                margin: '4px 0'
                            }}>
                                <h3 style={{
                                    width: '100%',
                                    padding: '8px',
                                    margin: 0,
                                    color: '#ffffff',
                                    fontSize: '28px',
                                    fontWeight: '600',
                                    backgroundColor: '#ff7f27',
                                    borderRadius: '8px'
                                }}>班蝶樓回收箱</h3>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '4px',
                                }}>
                                    {displaydev
                                        .map((dev_item, index) => (
                                            <td key={index} className="bincellstyle device-cell" style={{
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                                overflow: "hidden",
                                                color: "#f7f4ef",
                                                backgroundColor: "#525252",
                                          }}
                                                onMouseEnter={() => handleCellEnter(dev_item.id)}
                                                onMouseLeave={() => handleCellLeave(dev_item.id)}>
                                                <table>
                                                    <td>
                                                        <tr>{dev_item.label}</tr>
                                                        <tr>
                                                            <div style={{
                                                                fontSize: "34px",
                                                                fontWeight: "bold",
                                                                color: TextColors[index % 4]
                                                            }}>
                                                                {dev_item.unit}
                                                            </div>
                                                        </tr>
                                                    </td>
                                                    <td>
                                                        <br />
                                                        <BinIcon x={dev_item.status} src={cellColors_png[index % 4]} />
                                                    </td>
                                                </table>
                                            </td>
                                        ))}
                                </div>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        );
    };

    return (
        <div className="containerstyle">
            <table>
                <tbody>
                    <tr>
                        <td style={{ verticalAlign: "top", width: "760px" }}>
                            <table style={{ verticalAlign: "top" }}>
                                <tbody>
                                    <tr>
                                        {!isLoading && (
                                            <div className="floorpin">
                                                <FloorplanImage src={groundFloor} alt="Ground Floor" />
                                                <ImageWithPins pins={pins_g} hoveredDeviceId={hoveredDeviceId} />
                                            </div>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1000px" }}>
                                <tbody>
                                    <DeviceList />
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}